<template>
  <v-main>
    <v-container fluid>
      <!-- Generamos el AppBar con las distintas acciones -->
      <v-app-bar color="primary" dense dark style="border-radius: 5px">
        <!-- Crear una nuevo cliente -->
        <v-btn text @click="open_dialog_gasto()">
          <v-icon>mdi-file-outline</v-icon>
          <span class="appbar_button">{{ $t('Nuevo Gasto') }}</span>
        </v-btn>

        <FormGastoPeriodico
            v-if="gastos_periodicos.dialog_gasto_periodico"
            v-model="gastos_periodicos.dialog_gasto_periodico"
            :item="gastos_periodicos.gasto"
            @on_save="save_gasto"
        />
        <v-spacer />
          <v-btn icon href="https://www.youtube.com/playlist?list=PL2a9kD1kP16dTMApbdGWurQ0kC-iKrip_">
              <v-icon>mdi-video</v-icon>
          </v-btn>
      </v-app-bar>
      <!-- Tab del apartado -->
      <v-tabs class="elevation-2" grow id="tabs_gastos" v-model="active_tab">
        <v-tab href="#tab-categorias">
            <span class="tab_title">{{ $t('Categorías') }}</span>
        </v-tab>

        <v-tab href="#tab-periodicos">
          <span class="tab_title">{{ $t('Gastos periódicos') }}</span>
        </v-tab>

        <v-tab href="#tab-movimientos">
          <span class="tab_title">{{ $t('Movimientos') }}</span>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="active_tab" class="elevation-2" touchless>
        <v-tab-item value="tab-categorias" class="pa-4 grey lighten-5">
          <div>
            <!--  Boton para crear una nueva categoría -->
            <div class="text-right my-4">
              <v-btn small color="primary" @click="open_dialog_categoria()">
                <!--                <span class="caption">{{ $t('Crear categoría') }}</span>-->
                {{ $t('Nueva categoría') }}
              </v-btn>
            </div>
            <!-- Tabla de categorias de gastos -->
            <v-data-table
                :headers="categorias.tabla.headers"
                :items="categorias.tabla.categorias_gastos"
                :options.sync="categorias.tabla.options"
                :server-items-length="categorias.tabla.count"
                :fixed-header="true"
                class="elevation-3"
                calculate-widths
                :footer-props="{ itemsPerPageOptions: [5, 10, 20, 50], itemsPerPageText: $t('Registros por página') }"
            >
              <!-- Editar categoria o eliminarla -->
              <template v-slot:item.actions="{ item }">
                <v-btn color="primary" icon @click="open_dialog_categoria(item)" :title="$t('Editar categoría')">
                  <v-icon
                  >mdi-pencil
                  </v-icon>
                </v-btn>
                <v-btn icon color="red"
                       @click="eliminar_categoria(item.id)"
                       :title="$t('Eliminar categoría')">
                  <v-icon
                  >mdi-delete
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </div>

          <!-- Dialog de categoría de gasto -->
          <FormCategoriaGasto v-model="categorias.dialog_categoria" :item="categorias.categoria"
                              v-if="categorias.dialog_categoria" @on_save="get_categorias()"/>
        </v-tab-item>

        <v-tab-item value="tab-periodicos" class="pa-4 grey lighten-5">
          <!-- Mensaje informativo  -->
          <div class="container_info_azul">
            <span>{{
                $t('Puedes crear gastos puntuales o periódicos que se generarán en el tiempo automáticamente según la periodicidad seleccionada.')
              }}</span>
          </div>
          <!-- Buscador -->
          <Buscador @search="buscar_gastos_periodicos"/>
          <!-- Tabla de gastos periodicos -->
          <v-data-table
              :headers="gastos_periodicos.tabla.headers"
              :items="gastos_periodicos.tabla.gastos"
              :options.sync="gastos_periodicos.tabla.options"
              :server-items-length="gastos_periodicos.tabla.count"
              :fixed-header="true"
              :footer-props="{ itemsPerPageOptions: [5, 10, 20, 50], itemsPerPageText: $t('Registros por página') }"
              class="elevation-3"
              :item-class="gasto_class"
              calculate-widths
          >
            <!-- Importe -->
            <template v-slot:item.importe="{item}">
              {{ item.importe }} {{ $store.state.centro.centro.divisa.simbolo }}
            </template>
            <!-- Columna de acciones -->
            <template v-slot:item.actions="{item}">
              <v-btn icon color="primary" @click="open_dialog_gasto(item)" :title="$t('Editar gasto')">
                <v-icon
                >mdi-pencil
                </v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-tab-item>

        <v-tab-item value="tab-movimientos" class="pa-4 grey lighten-5">
          <!--  Boton para exportar los movimientos de la tabla -->
          <div class="text-right">
            <v-btn fab small color="primary" @click="exportar()" :title="$t('Exportar movimientos')">
              <!--              <span class="caption">{{ $t('Exportar movimientos') }}</span>-->
              <v-icon small>mdi-cloud-download</v-icon>
            </v-btn>
          </div>
          <!-- Filtro de busqueda -->
          <v-expansion-panels focusable class="my-4">
            <v-expansion-panel>
              <v-expansion-panel-header class="titulo_buscador">
                <span>
                  <v-icon large>mdi-magnify</v-icon>
                  {{ $t("Buscar") }}
                </span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-form>
                  <!-- Filtro -->
                  <v-row align="center">
                    <!-- Referencia -->
                    <v-col cols="12" sm="6" lg="2" class="pt-3 pb-0">
                      <v-text-field v-model="movimientos.tabla.filtros.ref" :label="$t('Referencia')"
                                    @keyup.enter="filter_movimiento_gasto()"></v-text-field>
                    </v-col>
                    <!-- Descripción -->
                    <v-col cols="12" sm="6" lg="2" class="pt-3 pb-0">
                      <v-text-field
                          v-model="movimientos.tabla.filtros.descripcion"
                          :label="$t('Descripción')"
                          @keyup.enter="filter_movimiento_gasto()"
                      ></v-text-field>
                    </v-col>
                    <!-- Fecha del movimiento -->
                    <v-col cols="12" sm="6" lg="3" class="pt-3 pb-0">
                      <DatePickerRange :title="$t('Fecha')" v-model="movimientos.tabla.filtros.fecha"/>
                    </v-col>
                    <!-- Rango de importes -->
                    <v-col cols="12" sm="6" lg="4" class="pt-3 pb-0">
                      <v-row class="ma-0" align="center">
                        <v-col cols="5" class="pa-0">
                          <v-text-field
                              v-model="movimientos.tabla.filtros.importe_min"
                              :label="$t('Importe min')"
                              @keyup.enter="filter_movimiento_gasto()"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="1" class="pa-0 mx-2 grey lighten-3 text-center elevation-2">
                          <span>{{ $t('a') }}</span>
                        </v-col>
                        <v-col cols="5" class="pa-0">
                          <v-text-field
                              v-model="movimientos.tabla.filtros.importe_max"
                              :label="$t('Importe max')"
                              @keyup.enter="filter_movimiento_gasto()"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <!-- Buscar -->
                    <v-col class="pt-3 pb-0 text-end">
                      <v-btn fab small right class="primary" @click="filter_movimiento_gasto()">
                        <v-icon small>mdi-magnify</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- Tabla de movimientos -->
          <v-data-table
              :headers="movimientos.tabla.headers"
              :items="movimientos.tabla.movimientos"
              :options.sync="movimientos.tabla.options"
              :server-items-length="movimientos.tabla.count"
              :fixed-header="true"
              class="elevation-3"
              calculate-widths
              :footer-props="{ itemsPerPageOptions: [5, 10, 20, 50], itemsPerPageText: $t('Registros por página') }"
          >
            <!-- Columna de fecha -->
            <template v-slot:item.fecha="{ item }">{{ item.fecha | moment('YYYY-MM-DD') }}</template>
            <!-- Columna de importe -->
            <template v-slot:item.importe="{ item }">
              {{ item.importe | money }}
            </template>
            <!-- Columna de acciones -->
            <template v-slot:item.actions="{ item }">
              <v-btn icon color="primary" @click="open_dialog_movimiento(item)" :title="$t('Editar movimiento')">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                  icon v-if="item.gasto_periodicidad === 1"
                  @click="eliminar_movimiento(item.id)"
                  :title="$t('Eliminar movimiento')" color="red"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>

          <!-- Formulario movimiento de gasto -->
          <FormMovimientoGasto
              v-if="movimientos.dialog_movimiento_gasto"
              v-model="movimientos.dialog_movimiento_gasto"
              :item="movimientos.movimiento"
              @on_save="filter_movimiento_gasto"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </v-main>
</template>


<script>

const PERIODICIDAD_PUNTUAL = 1

export default {
  name: 'Gastos',
  data: () => ({
    // Indica que tab es el activo
    active_tab: undefined,
    // Apartado de categorías
    categorias: {
      categoria: null,
      dialog_categoria: false,
      tabla: {
        categorias_gastos: [],
        count: 0,
        headers: [],
        options: {
          itemsPerPage: localStorage.getItem('itemsPerPage') ? parseInt(localStorage.getItem('itemsPerPage')) :  10
        },
        filtros: {
          limit: 10
        }
      }
    },
    // Apartado de gastos periódicos
    gastos_periodicos: {
      dialog_gasto_periodico: false,
      tabla: {
        tipos_periodicidad: [
          {value: 1, text: 'Puntual'},
          {value: 2, text: 'Diario'},
          {value: 3, text: 'Semanal'},
          {value: 4, text: 'Mensual'},
          {value: 5, text: 'Bimensual'},
          {value: 6, text: 'Trimestral'},
          {value: 7, text: 'Anual'},
          {value: 8, text: 'Semestral'}
        ],
        gastos: [],
        count: 0,
        headers: [],
        options: {
          itemsPerPage: localStorage.getItem('itemsPerPage') ? parseInt(localStorage.getItem('itemsPerPage')) :  10
        },
        filtros: {
          limit: 10
        }
      }
    },
    // Apartado de movimientos de gasto
    movimientos: {
      movimiento: null,
      dialog_movimiento_gasto: false,
      tabla: {
        count: 0,
        movimientos: [],
        headers: [],
        options: {
          itemsPerPage: localStorage.getItem('itemsPerPage') ? parseInt(localStorage.getItem('itemsPerPage')) :  10,
        },
        filtros: {
          limit: 10,
          fecha: [],
          ref: "",
          descripcion: "",
          importe_min: "",
          importe_max: "",
        }
      }
    }
  }),

  // Observamos el campo
  watch: {
    'categorias.tabla.options': {
      handler(value) {
        // Cambiamos los params de la busqueda
        this.categorias.tabla.filtros.limit = value.itemsPerPage
        this.categorias.tabla.filtros.offset = ((value.page - 1) * value.itemsPerPage)

        if (value.sortBy.length) {
          let desc = value.sortDesc[0] === true ? '-' : ''
          this.categorias.tabla.filtros.ordering = `${desc}${value.sortBy[0]}`
        }
        this.get_categorias()
      }
    },
    'gastos_periodicos.tabla.options': {
      handler(value) {
        // Cambiamos los params de la busqueda
        this.gastos_periodicos.tabla.filtros.limit = value.itemsPerPage
        this.gastos_periodicos.tabla.filtros.offset = ((value.page - 1) * value.itemsPerPage)

        if (value.sortBy.length) {
          let desc = value.sortDesc[0] === true ? '-' : ''
          this.gastos_periodicos.tabla.filtros['ordering'] = `${desc}${value.sortBy[0].split('.').join('__')}`
        }
        this.get_gastos_periodicos()
      }
    },
    'movimientos.tabla.options': {
      handler(value) {
        this.movimientos.tabla.filtros.limit = value.itemsPerPage
        this.movimientos.tabla.filtros.offset = (value.page - 1) * value.itemsPerPage

        if (value.sortBy.length) {
          let desc = value.sortDesc[0] === true ? "-" : ""
          this.movimientos.tabla.filtros["ordering"] = `${desc}${value.sortBy[0].split(".").join("__")}`
        }

        this.get_movimientos_gasto()
      }
    }
  },

  methods: {
    /**
     * Recupera la lista de categorias del centro
     */
    async get_categorias() {
      try {
        const response = await this.$store.dispatch('categoria_gasto/get', this.categorias.tabla.filtros)
        this.categorias.tabla.count = response.count
        this.categorias.tabla.categorias_gastos = response.results
      } catch (e) {
        this.$snotify.error(
          this.$t("Ha ocurrido un error"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },
    /**
     * Elimina una categoría
     */
    eliminar_categoria(id) {
      this.$confirm(this.$t('¿Estás seguro que quieres eliminar definitivamente esta categoría?').toString()).then(async () => {
        try {
          await this.$store.dispatch('categoria_gasto/delete', id)
          this.$snotify.success(
            this.$t("Acción realizada con éxito"),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
          this.get_categorias()
        } catch (e) {
          this.$snotify.error(
            this.$t("Ha ocurrido un error"),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
        }
      })
    },
    /**
     * Abre el dialog de categoría de gastos para crear o editar una nueva
     * @param item
     */
    open_dialog_categoria(item) {
      this.categorias.categoria = item
      this.categorias.dialog_categoria = true
    },
    /**
     * Abre el dialogo del gasto (crear o editar)
     * @param item
     */
    open_dialog_gasto(item) {
      this.gastos_periodicos.gasto = item
      this.gastos_periodicos.dialog_gasto_periodico = true
    },
    /**
     * Comprueba que tipo de gasto se ha guardado y muestra la tabla correspondiente
     * @param item
     */
    save_gasto(item) {
      if (item.periodicidad !== PERIODICIDAD_PUNTUAL) {
        this.get_gastos_periodicos()
        this.active_tab = 'tab-periodicos'
      } else {
        this.get_movimientos_gasto()
        this.active_tab = 'tab-movimientos'
      }
    },
    /**
     * Recupera la lista de gastos del centro
     * */
    async get_gastos_periodicos() {
      try {
        const response = await this.$store.dispatch('gasto/get', this.gastos_periodicos.tabla.filtros)
        this.gastos_periodicos.tabla.count = response.count
        this.gastos_periodicos.tabla.gastos = response.results
      } catch (e) {
        this.$snotify.error(
          this.$t("Ha ocurrido un error"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },
    /**
     * Busca los gastos periódicos en función de la búsqueda por texto
     * @param search
     */
    buscar_gastos_periodicos(search) {
      this.gastos_periodicos.tabla.filtros.search = search
      this.gastos_periodicos.tabla.filtros.offset = 0
      this.gastos_periodicos.tabla.options.page = 1
      this.get_gastos_periodicos()
    },
    /**
     * Si el gasto esta desactivado lo tacha en rojo
     * @param item
     * @returns {string}
     */
    gasto_class(item) {
      return item.is_active ? '' : 'red--text text-decoration-line-through'
    },
    /**
     * Recoge los movimientos de gasto
     */
    async get_movimientos_gasto() {
      try {
        let filtro = {...this.movimientos.tabla.filtros}
        filtro['fecha_inicio'] = filtro['fecha'][0]
        filtro['fecha_fin'] = filtro['fecha'][1]
        const response = await this.$store.dispatch("movimiento_gasto/get", filtro)
        this.movimientos.tabla.count = response.count
        this.movimientos.tabla.movimientos = response.results
      } catch (e) {
        this.$snotify.error(
          this.$t("Ha ocurrido un error"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },

    async filter_movimiento_gasto(){
      this.movimientos.tabla.filtros.offset = 0
      this.movimientos.tabla.options.page = 1
      await this.get_movimientos_gasto()
    },
    /**
     * Elimina un movimiento de gasto
     * @param id
     * @returns {Promise<void>}
     */
    async eliminar_movimiento(id) {
      this.$confirm("¿Estás seguro que quieres eliminar definitivamente este movimiento?").then(
          async () => {
            try {
              await this.$store.dispatch("movimiento_gasto/delete", id)
              this.$snotify.success(
                this.$t("Acción realizada con éxito."),
                this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
              )
              this.get_movimientos_gasto()
            } catch (e) {
              this.$snotify.error(
                this.$t("Ha ocurrido un error"),
                this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
              )
            }
          })
    },
    /**
     * Exporta a excel los movimientos de gasto filtrados
     */
    async exportar() {
      this.movimientos.tabla.filtros['fecha_inicio'] = this.movimientos.tabla.filtros.fecha[0]
      this.movimientos.tabla.filtros['fecha_fin'] = this.movimientos.tabla.filtros.fecha[1]
      try {
        await this.$store.dispatch("movimiento_gasto/exportar", this.movimientos.tabla.filtros)
        this.$snotify.success(
          this.$t("Acción realizada con éxito"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      } catch (e) {
        this.$snotify.error(
          this.$t("Ha ocurrido un error"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },
    /**
     * Abre el dialogo del gasto (crear o editar)
     * @param item
     */
    open_dialog_movimiento(item) {
      this.movimientos.movimiento = item
      this.movimientos.dialog_movimiento_gasto = true
    },
  },

  mounted() {
    // Traducimos las cabeceras de las tablas
    this.categorias.tabla.headers = [
      {text: this.$t('Nombre'), value: 'nombre', class: "primary white--text", sortable: false},
      {text: '', value: 'actions', class: "primary white--text", sortable: false, align: 'right'}
    ]
    this.gastos_periodicos.tabla.headers = [
      {text: this.$t('Referencia'), value: 'referencia', class: "primary white--text"},
      {text: this.$t('Descripcion'), value: 'descripcion', class: "primary white--text pa-0"},
      {text: this.$t('Importe'), value: 'importe', class: "primary white--text pa-0"},
      {text: this.$t('Categoría'), value: 'categoria_obj.nombre', class: "primary white--text"},
      {text: this.$t('Fecha inicio'), value: 'fecha_inicio', class: "primary white--text"},
      {text: this.$t('Fecha fin'), value: 'fecha_fin', class: "primary white--text"},
      {text: this.$t('Periodicidad'), value: 'periodicidad_text', class: "primary white--text"},
      {text: this.$t('Fecha últ. movimiento'), value: 'fecha_ultimo_movimiento', class: "primary white--text"},
      {text: this.$t(''), value: 'actions', class: "primary white--text", sortable: false, width: '10px'},
    ]
    this.movimientos.tabla.headers = [
      {text: this.$t("Referencia"), value: "ref", class: "primary white--text"},
      {text: this.$t("Descripcion"), value: "descripcion", class: "primary white--text pa-0"},
      {text: this.$t("Importe"), value: "importe", class: "primary white--text pa-0"},
      {text: this.$t("Categoría"), value: "categoria.nombre", class: "primary white--text"},
      {text: this.$t("Fecha"), value: "fecha", class: "primary white--text"},
      {text: "", value: "actions", class: "primary white--text", sortable: false, align: "right", width: "10%"}
    ]

    this.movimientos.tabla.filtros.fecha.push(this.$moment().add(-3, 'months').format('YYYY-MM-DD'))
    this.movimientos.tabla.filtros.fecha.push(this.$moment().format('YYYY-MM-DD'))
  },

  // Importamos los Components generales
  components: {
    FormCategoriaGasto: () => import('@/views/Configuracion/Gastos/components/FormCategoriaGasto'),
    FormGastoPeriodico: () => import('@/views/Configuracion/Gastos/components/FormGastoPeriodico'),
    FormMovimientoGasto: () => import('@/views/Configuracion/Gastos/components/FormMovimientoGasto'),
  }
}
</script>
